// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + {"93":"contatti","559":"progetto","594":"about","717":"soluzioni","962":"store"}[chunkId] + "." + {"93":"bb520d0f","559":"5708d01d","594":"65602431","717":"dd094aad","962":"18e2567c"}[chunkId] + ".js";
};